import { type ReactNode } from 'react';
import { Tag } from '@hungryroot/icons';
import { Paragraph, Heading, Dimension } from '@hungryroot/ramen';
import styles from './OrderSummaryFooterOverlay.module.css';

interface Props {
  amountSummary: ReactNode;
  button: ReactNode;
  promo?: string;
  spendMoreNudge?: string;
  discount?: number;
  summaryText?: string;
}

export function OrderSummaryFooterOverlay({
  button,
  amountSummary,
  promo,
  spendMoreNudge,
  discount,
  summaryText = 'Order summary',
}: Props) {
  const orderSummaryStyle = styles['promo-success'];

  return (
    <Dimension level="two" data-testid="footer-overlay">
      {discount !== undefined && discount > 0 && (
        <div className={styles['savings-banner']}>
          <Paragraph
            variant="caption"
            className={styles['savings-banner-text']}
          >
            You're saving
            <Paragraph
              variant="caption"
              className={styles['savings-banner-amount']}
            >
              ${discount.toFixed(2)}
            </Paragraph>
            today
          </Paragraph>
        </div>
      )}
      <div className={styles['summary-container']}>
        <div className={styles.row}>
          <Heading variant="H5">{summaryText}</Heading>
          {amountSummary}
        </div>
        {spendMoreNudge ? (
          <Paragraph variant="caption" className={styles.nudge}>
            <span className={styles['nudge-copy']}>{spendMoreNudge}</span>
          </Paragraph>
        ) : (
          promo && (
            <Paragraph variant="caption" className={orderSummaryStyle}>
              <Tag />
              <span className={styles['promo-copy']}>{promo}</span>
            </Paragraph>
          )
        )}
        {button}
      </div>
    </Dimension>
  );
}
